import { render, staticRenderFns } from "./order_requests.vue?vue&type=template&id=d888d190&scoped=true&"
import script from "./order_requests.vue?vue&type=script&lang=js&"
export * from "./order_requests.vue?vue&type=script&lang=js&"
import style0 from "./order_requests.vue?vue&type=style&index=0&id=d888d190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d888d190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d888d190')) {
      api.createRecord('d888d190', component.options)
    } else {
      api.reload('d888d190', component.options)
    }
    module.hot.accept("./order_requests.vue?vue&type=template&id=d888d190&scoped=true&", function () {
      api.rerender('d888d190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_requests.vue"
export default component.exports